import { useEffect } from 'react'

const useScrollPosition = (documents = []) => {
  useEffect(() => {
    const { scrollPosition } = window.history.state || {}
    if (scrollPosition) {
      window.scrollTo(0, scrollPosition)
    }
  }, [documents.length])
}

export default useScrollPosition
